// v2.6.0 — Hook : génère/persiste un userId UUID v4 dans localStorage.
// IMPORTANT : utilise la MÊME clé que Chat.jsx ("jsonfirst_civ_userid") afin que
// /mon-compte et /chat partagent le même identifiant anonyme.

import { useEffect, useState } from "react";

const STORAGE_KEY = "jsonfirst_civ_userid";

function _genUuidV4() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  // Fallback simple — pas un vrai UUID v4 mais accepté par notre regex backend si on
  // n'est pas trop strict. Mieux vaut crypto.randomUUID natif (présent partout >2022).
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export default function useUserId() {
  const [userId, setUserId] = useState(() => {
    try {
      const existing = localStorage.getItem(STORAGE_KEY);
      if (existing) return existing;
      const id = _genUuidV4();
      localStorage.setItem(STORAGE_KEY, id);
      return id;
    } catch (_) {
      return _genUuidV4();
    }
  });

  // En cas de modification externe (Chat.jsx initialise sa propre id avec la même
  // clé : on resync si une autre instance a écrit).
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY && e.newValue) setUserId(e.newValue);
    };
    // 2026-07-08 — sessions par compte : changement d'identité dans le MÊME onglet.
    const onUseridChanged = (e) => {
      const next = (e && e.detail) || localStorage.getItem(STORAGE_KEY);
      if (next) setUserId(next);
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("aya:userid-changed", onUseridChanged);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("aya:userid-changed", onUseridChanged);
    };
  }, []);

  return userId;
}
